import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { apiErrorMessageKey } from '../../../lib/api';
import { useAcceptTermsMutation } from '../../../lib/auth';
import { toInternalLocation } from '../../../lib/internalLocation';
import { TermsConsentForm } from '../components/TermsConsentForm';

export function AcceptTermsPage({ redirect }: { redirect?: string }): ReactElement {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const mutation = useAcceptTermsMutation();

    const errorMessage = mutation.error
        ? t(apiErrorMessageKey(mutation.error, 'ERRORS.ACCEPT_TERMS_FAILED'))
        : undefined;

    return (
        <Stack spacing={4}>
            <Stack spacing={1}>
                <Typography variant="h5" component="h1">
                    {t('AUTH.ACCEPT_TERMS.TITLE')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {t('AUTH.ACCEPT_TERMS.DESCRIPTION')}
                </Typography>
            </Stack>

            <TermsConsentForm
                submitLabel={t('AUTH.ACCEPT_TERMS.SUBMIT')}
                isPending={mutation.isPending}
                errorMessage={errorMessage}
                onSubmit={() =>
                    mutation.mutate(undefined, { onSuccess: () => void navigate(toInternalLocation(redirect)) })
                }
            />
        </Stack>
    );
}
